import { render, staticRenderFns } from "./BiltyForm.vue?vue&type=template&id=516d8198&"
import script from "./BiltyForm.vue?vue&type=script&lang=js&"
export * from "./BiltyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports